import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-type-de-masque',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-type-de-masque.component.html',
  styleUrl: './traitement-data-type-de-masque.component.scss',
})
export class TraitementDataTypeDeMasqueComponent {
  @Input() patient: Patient | undefined;
}
